module.exports = __webpack_public_path__ + "img/home_button_shujuku.1f235e86.png";